import { Component, DesignerInterface } from "../../..";
import { SpecialParentType } from "../../../base/SpecialParentType";
import { Panel } from "../../panel/Panel";
import { PanelProps } from "../../panel/PanelProps";
import { Table } from "../../table/Table";

export abstract class AbstractTableToolsPanel extends Panel {
    readonly table: Table;

    constructor(table: Table, props?: Partial<PanelProps>) {
        super({
            wrap: false,
            rowBreak: false,
            rowBreakDefault: false,
            padding: 0,
            _designer: table._designer,
            ...props
        });
        this.table = table;
    }

    override get specialParentType(): SpecialParentType {
        return SpecialParentType.TABLE_HEADER_TOOLS_PANEL;
    }

    checkToolAvailability() {
        this.forEveryChildComponent(component => component.syncEnabled());
    }

    override add(...components: Component[]): Component {
        components?.forEach(component => component._designer = this.table._designer);
        const result = super.add(...components);
        components?.forEach(component => component.syncEnabled());
        this.evaluatePadding();
        return result;
    }

    override relayout() {
        super.relayout();
        this.evaluatePadding();
    }

    private evaluatePadding() {
        if (this.isEmpty())
            this.padding = 0;
        else {
            this.paddingLeft = this.getPopulatedPaddingLeft();
            this.paddingRight = this.getPopulatedPaddingRight();
            this.paddingTop = 0;
            this.paddingBottom = 0;
        }
    }

    abstract getPopulatedPaddingLeft(): number;
    abstract getPopulatedPaddingRight(): number;

    override get _designer(): DesignerInterface {
        return super._designer;
    }

    override set _designer(value: DesignerInterface) {
        super._designer = value;
        this.components.forEach(component => component._designer = value);
    }
}
